import styled from '@emotion/styled'

export const StyledLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em;
`
